import React from "react";
/** @jsx jsx */
/* @ts-ignore */
import { jsx, css, keyframes } from '@emotion/react';
import { GameClient, RoundRewardDisplay } from "../gameClient";
import { Colors } from "../palettes/colorPalette";
import { Multiplayer } from "../../../shared/constants";

const style = css`
	display: block;
	position: absolute;
	left: 50%;
	top: 7%;
`;

const rewardStyle = css`
	display: block;
	transition: top 1.0s;
	transform: translateX(-50%);
	background: gold;
	padding: 1vh;
	border-radius: 20px;
	position: relative;
`;

interface RewardDisplayProps {
	reward: RoundRewardDisplay,
}

declare var gameClient: GameClient;

export const RewardDisplay = (props: RewardDisplayProps) => {

	let topOffset = "0px";
	if (gameClient.getCurrentState() === "recap") {
		topOffset = "400px";
	}

	//Assumes two players here

	const isTiebreakerActive = gameClient.round >= Multiplayer.EarliestRewardRound;
	let color = Colors.UICarb;
	if (isTiebreakerActive) {
		color = Colors.UIAntibodyBackground;
	}

	return (
		<div css={style}>
			<div css={rewardStyle} style={{ top: topOffset, backgroundColor: color }}>
				Tiebreakers Active
			</div>
		</div>
	)
};
